import { render, staticRenderFns } from "./CdkFilterPassBadge.vue?vue&type=template&id=1068671b&functional=true&"
import script from "./CdkFilterPassBadge.vue?vue&type=script&lang=ts&"
export * from "./CdkFilterPassBadge.vue?vue&type=script&lang=ts&"
import style0 from "./CdkFilterPassBadge.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports